import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import SingleFieldManager from "@com/SingleFieldManager.vue";
export default {
  __name: 'HotelFacilitieManager',

  setup(__props) {
    const config = {
      name: '酒店设施',
      type: 'hotelFacilitie',
      route: 'hotelfacilitiemanager'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SingleFieldManager, {
        config: config
      });
    };
  }

};